module.exports = __webpack_public_path__ + "static/media/12-Fulham.4d7be154.mp4";